import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../api.ts';
import { ExtraInvoiceView } from '../../components/ExtraInvoiceView.tsx';
import type { ExtraInvoice } from './business/types.ts';

export function ExtraInvoicePage() {
  const { id } = useParams();
  const [invoice, setInvoice] = useState<ExtraInvoice | null | 'missing'>(null);

  useEffect(() => {
    api.get<{ invoice: ExtraInvoice }>(`/extra/invoices/${id}`).then((r) => setInvoice(r.invoice)).catch(() => setInvoice('missing'));
  }, [id]);

  return (
    <div style={{ maxWidth: 820, margin: '0 auto', padding: '24px 20px 48px' }}>
      <Link to="/extra/activite/factures" className="no-print" style={{ fontSize: 13, fontWeight: 700, color: 'var(--accent-dark)', textDecoration: 'none', display: 'inline-block', marginBottom: 14 }}>
        ← Retour à mes factures
      </Link>
      {invoice === null && <div className="empty-state">Chargement…</div>}
      {invoice === 'missing' && <div className="error-banner">Facture introuvable.</div>}
      {invoice && invoice !== 'missing' && <ExtraInvoiceView invoice={invoice} />}
    </div>
  );
}
